module.exports = __webpack_public_path__ + "img/Grupo 317.6e3724a1.svg";